import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

import { Account } from '@personal-area/global/accounts/models';
import { I18nService } from '@personal-area/global/i18n';

import { TradePopupComponent, TradePopupModalData } from '../trade-popup/trade-popup.component';

@Component({
  selector: 'global-trade-button',
  templateUrl: './trade-button.component.html',
  styleUrls: ['./trade-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
  ],
})
export class TradeButtonComponent {
  @Input() account?: Account;

  constructor(
    private _dialog: MatDialog,
    private _i18nService: I18nService,
  ) {
  }

  public controlTradeButton(account: Account): void {
    this._dialog.open<TradePopupComponent, TradePopupModalData>(TradePopupComponent, {
      panelClass: 'popup-container-450',
      data: {
        account,
      },
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
    });
  }
}
